import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Mises en avant catégories")
], -1)
const _hoisted_2 = { class: "flex justify-end w-full" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body pt-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "Actions", -1)

import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import Property from "@/models/product/property/Property";
import { ref, onMounted } from "vue";
import {fetchProperties} from "@/_services/property/property";
import {FilterMatchMode} from "primevue/api";
import router from "@/router";
import {deleteMegaMenuCategories, fetchMegaMenuCategories} from "@/_services/megaMenuCategories/megaMenuCategories";
import {IMasterProduct} from "@/models/product/IMasterProduct";
import swal from "@/_helpers/swal";
import {productService} from "@/_services/product/product";

export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenuCategoriesList',
  setup(__props) {

const currentPage = ref(1);
const rowsPerPage = ref(10);
const totalRecords = ref(0);
const rows = ref<number>(10);
const isLoading = ref<boolean>(true);
const properties = Array<Property>();
const tableData = ref<Array<Property>>(properties);
const editMegaMenu = (megaMenuUuid: string) => {
    router.push({ name: 'editMegaMenusCategories', params: { uuid: megaMenuUuid } });
};
onMounted(async () => {
    await populateDatatable();
});
const populateDatatable = async () => {
    const paginationData = await fetchMegaMenuCategories(currentPage.value, rowsPerPage.value);
    isLoading.value = paginationData.isLoading.value;
    tableData.value = paginationData.tableData.value;
    console.log(tableData.value)
    totalRecords.value = paginationData.totalRecords.value;
};

const onPaginate = (event) => {
    currentPage.value = event.page + 1; 
    rowsPerPage.value = event.rows;
    populateDatatable();
};
const onDelete = (megaMenuUuid) => {
    swal
        .confirm("Êtes vous sur de vouloir supprimer cette mise en avant ?")
        .then((result) => {
            if (result.isConfirmed) {
                 deleteMegaMenuCategories(megaMenuUuid).then(() => {
                    swal.success("Supprimé !", "Vous venez de supprimer cette mise en avant ");
                    populateDatatable();
                });
            }
        });
};

const addHilight = () => {
    router.push("/admin/catalogue/megaMenusCategories/add");
   
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Button), {
        label: "Ajouter une mise en avant",
        onClick: addHilight,
        icon: "pi pi-plus",
        "aria-label": "Ajouter une mise en avant",
        class: "button-add"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        paginator: true,
        rows: rowsPerPage.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        rowsPerPageOptions: [10, 25, 50, 100],
        onPage: onPaginate,
        lazy: ""
      }, {
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Column), {
              field: "name",
              header: "Nom du lien"
            }),
            _createVNode(_unref(Column), {
              field: "category.name",
              header: "Catégorie"
            }),
            _createVNode(_unref(Column), { headerStyle: "width: 12em;" }, {
              header: _withCtx(() => [
                _hoisted_5
              ]),
              body: _withCtx((slotProps) => [
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-pencil",
                  class: _normalizeClass(["p-edition", `${slotProps.data.uuid}`]),
                  style: {"margin-right":"0.5em"},
                  title: "Éditer",
                  onClick: ($event: any) => (editMegaMenu(slotProps.data.uuid))
                }, null, 8, ["class", "onClick"]),
                _createVNode(_unref(Button), {
                  size: "small",
                  icon: "pi pi-trash",
                  class: "p-button-danger",
                  style: {"margin-right":"0.5em"},
                  title: "Supprimer",
                  onClick: ($event: any) => (onDelete(slotProps.data.uuid))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage"])
    ])
  ], 64))
}
}

})